import React from 'react';

import { flagStyles } from '../settings';

const SvgJM = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2640px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgJM;
